const useTrackSearch = (searchTerm: string) => {
    if (window.gtag) {
        window.gtag('event', 'search', {
            'search_term': searchTerm,
        })
    }
}

export { useTrackSearch }
